import dateformat from 'dateformat';
import { SeparationType } from '../../enums/SeparationType';
import { useAuth } from '../../contexts/AuthContext';
import { SessionHelper } from '../../helpers/SessionHelper';
import { OrderForListing } from '../../models/OrderForListing';
import { StatePrescriptionLog } from '../../models/StatePrescriptionLog';
import { IWidthColumnOrdersTable } from './useOrdersTable';
import { RecipePopover } from './RecipePopover';
import { TableData } from './styles';

interface StateIPrescriptionTableDataProps {
  separationType?: SeparationType;
  orderForListing: OrderForListing;
  newStatePrescription?: StatePrescriptionLog;
  widthColumn: IWidthColumnOrdersTable;
  backgroundColor?: string;
}

export const StatePrescriptionTableData: React.FC<StateIPrescriptionTableDataProps> = ({
  separationType,
  orderForListing,
  newStatePrescription,
  widthColumn,
  backgroundColor
}) => {

  const { session } = useAuth();
  const canSeeSimpleTable = SessionHelper.canSeeSimpleTable(session);

  if (separationType !== SeparationType.Prescription || canSeeSimpleTable) return null;

  const currentStatePrescriptionName = newStatePrescription?.currentStateDescription || orderForListing.currentStatePrescriptionName;
  const currentStatePrescriptionCreatedAt = newStatePrescription?.createdAt || orderForListing.statePrescriptionLog?.createdAt;

  return (
    <TableData width={widthColumn.StateDegree} backgroundColor={backgroundColor}>
      <div>
        {currentStatePrescriptionName}
        <RecipePopover separationType={separationType} orderForListing={orderForListing} />
      </div>
      {currentStatePrescriptionCreatedAt ? <div style={{fontSize:'0.6em', color:'#969697'}}>{dateformat(currentStatePrescriptionCreatedAt, 'dd/mm/yy HH:MM')}</div> : '' }
    </TableData>
  );

}